export const generativeAiAgentsModels = "/generative_ai/agents/models";
